module.exports = __webpack_public_path__ + "img/8.db41a8e8.png";